import type { AppProps } from "next/app";

import "~/styles/globals.css";
import { useRouter } from "next/router";
import RootLayout from "~/components/layouts/root-layout";
import { api } from "~/utils/api";

import AuthChecker from "~/components/auth/auth-checker";
import { PageLoader } from "~/components/ui/page-loader";
import TypesafeI18n from "~/i18n/i18n-react";
import type { Locales } from "~/i18n/i18n-types";
import { loadAllLocales } from "~/i18n/i18n-util.sync";
import { useSession } from "~/utils/auth-client";

loadAllLocales();

function MyApp({ pageProps, Component }: AppProps) {
	const { locale: nextLocale, pathname } = useRouter();
	const { data: session, isPending } = useSession();

	// Show loading while checking authentication
	if (isPending) {
		return (
			<TypesafeI18n locale={nextLocale as Locales}>
				<RootLayout>
					<PageLoader />
				</RootLayout>
			</TypesafeI18n>
		);
	}

	// If not authenticated and not on login page, don't render the component
	// Let AuthChecker handle the redirect
	if (!session && pathname !== "/auth/login") {
		return (
			<TypesafeI18n locale={nextLocale as Locales}>
				<RootLayout>
					<AuthChecker />
				</RootLayout>
			</TypesafeI18n>
		);
	}

	return (
		<TypesafeI18n locale={nextLocale as Locales}>
			<RootLayout>
				<AuthChecker />
				<Component {...pageProps} />
			</RootLayout>
		</TypesafeI18n>
	);
}

export default api.withTRPC(MyApp);
